import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { handleActions } from 'redux-actions';
import { reduxModuleLoaded, overrideSubscribeMatureFilter } from './actions';
const reducers = handleActions({
    [reduxModuleLoaded.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            reduxReady: true
        }),
    [overrideSubscribeMatureFilter.toString()]: (state, { payload  })=>_object_spread_props(_object_spread({}, state), {
            matureFilterOverrides: [
                payload.tier.deviationId,
                ...state.matureFilterOverrides
            ]
        })
}, {
    reduxReady: false,
    matureFilterOverrides: []
});
export default reducers;
